import { apolloClient } from 'lib/withApollo'
import CATEGORIES_QUERY from 'graphql/categories.query'
import POSTS_QUERY from 'graphql/posts.query'
import { NEWS_POSTS_PER_PAGE } from '@constants'
import getSitesForStaticPaths from 'helpers/getSitesForStaticPaths'

import Archive from 'pages/[site]/news/archive/[page]'

function CategoryArchivePage(props) {
  return <Archive {...props} />
}

export default CategoryArchivePage

export async function getStaticProps({ params }) {
  const { site, categorySlug, page } = params

  const { data, error } = await apolloClient().query({
    query: POSTS_QUERY,
    context: { site },
    variables: {
      categoryName: categorySlug,
      featuredInBlocks: true,
      withCategoriesMenu: true,
      offset: page ? (parseInt(page, 10) - 1) * NEWS_POSTS_PER_PAGE : null,
    },
  })

  if (error) console.log(`Error loading News Category Archive props - ${error}`)

  return {
    props: {
      ...params,
      posts: data.posts.nodes,
      categoriesMenu: data.pageBy.acfNews.categoriesMenu,
      offsetPagination: data.posts.pageInfo.offsetPagination,
    },
    revalidate: 60 * 2,
  }
}
export async function getStaticPaths() {
  const paths = []

  // const sites = await getSitesForStaticPaths(
  //   ({ site }) => ({
  //     query: CATEGORIES_QUERY,
  //     context: { site },
  //   }),
  //   async (data, { client, site }) =>
  //     Promise.all(
  //       data.categories.nodes
  //         .filter(c => c.slug !== 'uncategorised')
  //         .map(c =>
  //           client
  //             .query({
  //               query: POSTS_QUERY,
  //               context: { site },
  //               variables: {
  //                 categoryName: c.slug,
  //                 limit: 1,
  //               },
  //             })
  //             .then(({ data }) => [
  //               c.slug,
  //               Math.ceil(
  //                 data.posts.pageInfo.offsetPagination.total /
  //                   NEWS_POSTS_PER_PAGE
  //               ),
  //             ])
  //         )
  //     )
  // )

  // sites.forEach(site => {
  //   site[1].forEach(p => {
  //     for (let i = 0; i < p[1] - 1; i++) {
  //       paths.push({
  //         params: {
  //           site: site[0],
  //           categorySlug: p[0],
  //           page: (i + 2).toString(),
  //         },
  //       })
  //     }
  //   })
  // })

  return {
    paths,
    fallback: true,
  }
}
